import React from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import classNames from 'classnames';
import { get, kebabCase } from 'lodash';

import { IconCollapseArrow } from '@/components/icons/IconCollapseArrow';

import { Props } from './types';

import styles from './DropdownSelector.module.scss';

export const DropdownSelector = <T,>(props: Props<T>) => {
  const {
    name,
    value,
    options,
    optionNameAccessor,
    selectedOption,
    hasNoneOption = false,
    classes,
    isOpen,
    onToggle,
    onSelect,
  } = props;

  return (
    <Dropdown
      className={classNames(styles.dropdown, classes?.dropdown)}
      data-testid={`${name}-dropdown-wrapper`}
      isOpen={isOpen}
      menuRole="listbox"
      toggle={onToggle}
    >
      <DropdownToggle
        cssModule={{
          btn: styles.dropdown_button,
          'btn-secondary': styles.focused_dropdown_button,
        }}
        data-testid={`${name}-dropdown-value`}
      >
        <div
          className={classNames({
            [styles.placeholder]: selectedOption === undefined,
          })}
        >
          {value}
        </div>
        <div className={styles.collapse_arrow_wrapper}>
          <IconCollapseArrow className={isOpen ? styles.open : styles.closed} color="#606366" />
        </div>
      </DropdownToggle>
      <DropdownMenu
        cssModule={{
          'dropdown-menu': styles.dropdown_menu,
          show: styles.dropdown_menu_show,
        }}
      >
        {hasNoneOption && (
          <DropdownItem
            cssModule={{ 'dropdown-item': styles.dropdown_item }}
            data-testid="dropdown-item-none"
            onClick={() => onSelect(null)}
          >
            None
          </DropdownItem>
        )}
        {options.map(item => (
          <DropdownItem
            cssModule={{ 'dropdown-item': styles.dropdown_item }}
            data-testid={kebabCase(`dropdown-item-${get(item, optionNameAccessor)}`)}
            key={get(item, optionNameAccessor)}
            onClick={() => onSelect(item)}
          >
            {get(item, optionNameAccessor)}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};
